import { compose, join, keys, map, isEmpty, constant } from 'lodash/fp';
import { omitFalsyValues, ifElse } from '@mews/fp';
import { appendEmptyString } from '@mews-commander/utils';
import { Shortcuts } from './Shortcuts';
import { ShortcutKey } from './constants';

const modifiersMap = {
    altKey: 'Alt',
    ctrlKey: 'Ctrl/Cmd',
};

const getModifierLabels = compose(
    ifElse(isEmpty, constant(''), compose(join(' + '), appendEmptyString)),
    map<string, string>((k) => modifiersMap[k as keyof typeof modifiersMap]),
    keys,
    omitFalsyValues
);

export const stringifyShortcut = (key: ShortcutKey) => {
    const shortcut = Shortcuts[key];

    if (!shortcut) {
        return '';
    }

    const modifierLabels = getModifierLabels(shortcut.modifiers);
    const prefixes = /^key|digit/i;
    const keyLabel = key.replace(prefixes, '');

    return `${modifierLabels}${keyLabel}`;
};
